import Image from 'next/image';
import { useRouter } from 'next/router';
import type { FC } from 'react';

import React from 'react';
import type { Service } from '@/api/cms/services/type';
import type { DefaultCmsDataResponse } from '@/api/cms/types';
import Container from '@/components/layouts/Container';
import { baseUrl, CityId } from '@/lib/constants';
import InformationBanner from '@/modules/service/InformationBanner';
import AhaTruckPriceSlider from './AhaTruckPriceSlider';

type Props = {
  // Declare AhaTruckPrice Page props
  services: DefaultCmsDataResponse<Service>[];
};

export const AhaTruckPricePage: FC<Props> = ({ services }) => {
  const { query } = useRouter();
  const { city } = query;

  const title = 'Bảng giá thuê xe tải chở hàng';

  const cityId = React.useMemo(() => {
    if (city) {
      return city.toString().toLocaleUpperCase() as CityId;
    }
  }, [city]);

  const titleSuffix = React.useMemo(() => {
    if (!cityId) {
      return '';
    }

    switch (cityId) {
      case CityId.HAN:
        return 'tại Hà Nội';

      case CityId.HCM:
        return 'tại Thành phố Hồ Chí Minh';

      case CityId.DAD:
        return 'tại Đà Nẵng';

      default:
        return '';
    }
  }, [cityId]);

  return (
    <Container
      // title={title + (titleSuffix ? ` ${titleSuffix}` : '')}
      title="Bảng giá dịch vụ thuê xe tải chi tiết tại Ahamove"
      description="Khám phá bảng giá thuê xe tải Ahamove chi tiết và cập nhật mới nhất! Tìm hiểu giá cước và các gói đi kèm khi thuê xe tải vận chuyển tại đây."
      openGraph={{
        type: 'website',
        site_name: process.env.NEXT_PUBLIC_APP_NAME,
        title: title + (titleSuffix ? ` ${titleSuffix}` : ''),
        images: [
          {
            url: `${baseUrl}/static/images/service/banner-truck-desktop.webp`,
            height: 800,
            width: 1200,
            alt: title + (titleSuffix ? ` ${titleSuffix}` : ''),
          },
        ],
      }}
    >
      <main className="mt-header-mobile desktop:mt-header-desktop min-h-content flex w-full grow flex-col">
        <InformationBanner
          title={
            <>
              {title}
              {titleSuffix ? (
                <>
                  <br />
                  {titleSuffix}
                </>
              ) : (
                ''
              )}
            </>
          }
        />
        {services.length > 0 ? (
          <AhaTruckPriceSlider cityId={cityId} services={services} />
        ) : (
          <div className="min-h-content desktop:py-20 py-12">
            <div className="relative mx-auto aspect-video w-full max-w-[431px]">
              <Image
                src="/static/icons/FileBrokenOrNotFound.svg"
                alt="No service"
                fill
              />
            </div>
          </div>
        )}
      </main>
    </Container>
  );
};
